// extracted by mini-css-extract-plugin
module.exports = {"campaignBox":"styles_campaignBox__kzvZQ","campaignTitle":"styles_campaignTitle__4kxob","campaignDesc":"styles_campaignDesc__pQbZl"};
module.exports.__checksum = "31cbc504cb89"